"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeRangeValue = exports.prefixZero = exports.prefix = void 0;
/**
 * 给或者数字添加前缀符号
 * @param val 数字或者字符串值
 * @param len 补足的字符串长度
 * @param sign 补充的标识
 */
var assertFunctions_1 = require("./assertFunctions");
function prefix(val, len, sign) {
    if (len === void 0) { len = 2; }
    if (sign === void 0) { sign = "0"; }
    return String(val).length >= len
        ? (val + "")
        : (new Array(len).join(sign) + val).slice(-len);
}
exports.prefix = prefix;
function prefixZero(val, len) {
    if (len === void 0) { len = 2; }
    assertFunctions_1.assertNumber(val, "val");
    return prefix(val, len, "0");
}
exports.prefixZero = prefixZero;
/**
 * 安全地取一个区间内的某一个值
 * @param value 目标值
 * @param range 区间数组
 */
function safeRangeValue(value, range) {
    return Math.min(Math.max(value, range[0]), range[1]);
}
exports.safeRangeValue = safeRangeValue;
